import { createAction } from 'redux-actions';
import message from '@itt/frontend-scaffold-components/dist/Message/Message';
import { SET_MESSAGES, SET_TOTAL, SET_LOADING, RESET } from './actionTypes';
import STATUS_CODE from '../../../request/statusCode';
import {
  getMessages,
  createMessage,
  updateMessage,
  deleteMessage
} from './service';

const setMessages = createAction(SET_MESSAGES);
const setTotal = createAction(SET_TOTAL);
const setLoading = createAction(SET_LOADING);
const reset = createAction(RESET);

const getAllMessages = ({ page, size, sort, status }) => {
  return dispatch => {
    dispatch(setLoading(true));
    return getMessages({ page, size, sort, status }).then(res => {
      dispatch(setLoading(false));
      if (res.statusCode === STATUS_CODE.OK) {
        const { content, totalElements } = res.data;
        dispatch(setMessages(content));
        dispatch(setTotal(totalElements));
      } else {
        dispatch(setMessages([]));
        dispatch(setTotal(0));
      }
    });
  };
};

const create = ({
  messageText,
  startTime,
  endTime,
  page,
  size,
  sort,
  status
}) => {
  return dispatch => {
    return createMessage({
      message: messageText,
      startTime,
      endTime
    }).then(res => {
      if (res.statusCode === STATUS_CODE.OK) {
        message.success('Message created successfully!');
        dispatch(getAllMessages({ page, size, sort, status }));
        return true;
      }
      return false;
    });
  };
};

const edit = ({
  id,
  messageText,
  startTime,
  endTime,
  page,
  size,
  sort,
  status
}) => {
  return dispatch => {
    return updateMessage({
      id,
      message: messageText,
      startTime,
      endTime
    }).then(res => {
      if (res.statusCode === STATUS_CODE.OK) {
        message.success('Message edited successfully!');
        dispatch(getAllMessages({ page, size, sort, status }));
        return true;
      }
      return false;
    });
  };
};

const remove = ({ id, page, size, sort, status }) => {
  return dispatch => {
    return deleteMessage({ id }).then(res => {
      if (res.statusCode === STATUS_CODE.OK) {
        message.success('Message deleted successfully!');
        dispatch(getAllMessages({ page, size, sort, status }));
        return true;
      }
      return false;
    });
  };
};

export {
  setMessages,
  setTotal,
  setLoading,
  reset,
  getAllMessages,
  create,
  edit,
  remove
};
